export default __webpack_public_path__ + "static/media/signin.42e10299.png";